<template>
  <p class="authentication-redirect-countdown">
    Você será redirecionado para pesquisa em {{ secondsRemaining }} segundos.
  </p>
</template>

<script>
export default {
  props: {
    duration: {
      type: Number,
      default: 10
    },
    redirectUrl: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      secondsRemaining: this.duration,
      interval: null
    }
  },

  mounted() {
    this.interval = window.setInterval(() => {
      if (this.secondsRemaining <= 1) {
        this.clearCountdown()
        window.location.href = this.redirectUrl
        return
      }

      this.secondsRemaining -= 1
    }, 1000)
  },

  beforeDestroy() {
    this.clearCountdown()
  },

  methods: {
    clearCountdown() {
      if (!this.interval) return

      window.clearInterval(this.interval)
      this.interval = null
    }
  }
}
</script>
